
import Vue from 'vue'
import App from './App.vue'
import axios from "axios";
import store from './store';
// 引入路由器
import router from './router'  // 会自动找到router文件夹下index.js文件
Vue.config.productionTip = false
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import * as echarts from 'echarts';

Vue.prototype.$echarts = echarts;
Vue.use(ElementUI)
new Vue({
    store,
    router,  // 组件注入：通过 router 配置参数注入路由，从而让整个应用支持路由功能
    render: h => h(App)
}).$mount('#app')
